<div class="w-100">
  <app-retailer-paymentrequest-new></app-retailer-paymentrequest-new>
</div>
